<app-tab-button (onClick)="toggleFilter()" [icon]="faSlidersH" label="FILTERS"></app-tab-button>

<div class="filter-popup" appDisableBodyScroll *ngIf="showFilterPopup">
  <div class="row m-0 p-0">
    <div class="col-12 d-flex filter-header shadow-sm align-items-center">
      <button class="btn" (click)="toggleFilter()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
      <p><b>FILTERS</b></p>
      <span class="spacer"></span>
      <!-- TODO -->
      <!-- <button class="btn" (click)="clearAllFilter()">
        CLEAR ALL
      </button> -->
    </div>
    <div class="col-12 filter-content">
      <app-car-filters (filterChanged)="onFilterChanged($event)"></app-car-filters>
    </div>
    <div class="col-12 filter-footer d-flex align-items-center">
      {{totalRecordsFound}} cars found
      <span class="spacer"></span>
      <app-p3-button (onClick)="applyFilters()">
        APPLY FILTERS
      </app-p3-button>
    </div>
  </div>
</div>